import { SxProps, TextField } from '@mui/material';
import { Theme } from '@mui/system';
import React, { forwardRef } from 'react';
import { usePlacesWidget } from 'react-google-autocomplete';

interface LocationInputProps {
  id?: string;
  name: string;
  label?: string;
  placeholder?: string;
  value: unknown;
  defaultValue?: unknown;
  disabled?: boolean;
  error?: boolean;
  sx?: SxProps<Theme> | undefined;
  size?: 'small' | 'medium';
  maxRows?: number;
  multiline?: boolean;
  onFocus?: () => void;
  onChangeLocation: (address: string) => void;
  onChange?:
    | React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>
    | undefined;
  onBlur?:
    | React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>
    | undefined;
}

const LocationInput = forwardRef(
  ({
    onChangeLocation,
    name,
    label,
    id,
    size,
    defaultValue,
    onFocus,
    multiline,
    disabled,
    placeholder,
    error,
    maxRows,
    sx,
    onBlur,
    value
  }: LocationInputProps) => {
    // eslint-disable-next-line
    const handleLocation = (place: any) => {
      onChangeLocation(place.formatted_address);
    };

    const { ref: materialRef } = usePlacesWidget({
      apiKey: `${process.env.REACT_APP_GOOGLE_API}`,
      onPlaceSelected: (place) => handleLocation(place),
      inputAutocompleteValue: 'address',
      options: {
        types: ['address'],
        componentRestrictions: { country: 'us' },
        fields: ['formatted_address', 'geometry.location']
      }
    });

    return (
      <TextField
        variant="outlined"
        placeholder={placeholder ?? ''}
        label={label}
        inputRef={materialRef}
        size={size}
        id={id}
        multiline={multiline}
        name={name}
        disabled={disabled}
        error={error}
        maxRows={maxRows}
        defaultValue={defaultValue}
        onFocus={onFocus}
        sx={sx}
        onChange={handleLocation}
        onBlur={onBlur}
        value={value}
      />
    );
  }
);

LocationInput.displayName = 'LocationInput';

export default LocationInput;
